import { Post } from "core/blog";
import { Brand, Category, Product } from "core/catalog";

export const URLS = {
  notifications: "/notifications",
  home: "/",
  notFound: "/404",
  designSystem: "/design-system",
  affiliate: "/affiliate",
  maintenance: "/maintenance",
  cart: "/cart",
  wishlist: "/wishlist",
  checkout: {
    root: "/checkout",
    failedPayment: "/checkout/failed-payment",
    successPayment: (id: string) => `/checkout/success-payment/${id}`,
    successPaymentRoute: "/checkout/success-payment/:id",
    buyNow: (product: Product) => `/buy-now/${product.id}/${product.slug}`,
    buyNowRoute: "/buy-now/:id/:slug",
    guest: "/guest-checkout",
  },
  orderCompleted: "/order-completed",
  successCheckout: (order: any) => `/checkout/success/${order.id}`,
  paymentGate: (url: string) => `/checkout/payment-gate/${url}`,
  successCheckoutRoute: "/checkout/success/:id",
  paymentGateRoute: "/checkout/payment-gate/:id",
  blog: {
    list: "/blog",
    viewRoute: "/blog/:id/:slug",
    view: (post: Post) => `/blog/${post.id}/${post.slug}`,
  },
  faq: "/faq",
  auth: {
    root: "/auth",
    login: "/auth/login",
    register: "/auth/register",
    verifyRegister: "/auth/verify-register",
    resetPassword: "/auth/reset-password",
    forgetPassword: "/auth/forget-password",
    verifyCode: "/auth/verify-code",
    logout: "/auth/logout",
    loginByGoogle: "/auth/login/google",
  },
  brands: "/brands",
  account: {
    root: "/account",
    editProfile: "/account/update-profile",
    updatePassword: "/account/update-password",
    deleteAccount: "/account/delete-account",
    orders: "/account/orders",
    address: "/account/addresses",
    wishlist: "/account/wishlist",
    viewOrderRoute: "/account/orders/:id",
    viewOrder: (order: any) => `/account/orders/${order.id}`,
    cancelOrder: "/account/orders/cancel",
    cancelingReasons: "/account/orders/canceling-reasons",
  },
  shop: {
    list: "/shop",
    search: "/search",
    offers: "/offers",
    viewCategoryRoute: "/categories/:id/:slug",

    viewProductRoute: "/products/:id/:slug",
    CategoriesLayout: "/categories",
    ProductsLayout: "/products",
    BrandsLayout: "/brands",
    viewProduct: (product: Product) =>
      `/products/${product?.id}/${product?.slug}`,
    viewProductSimilar: (productId: number) =>
      `/products/${productId}/similar-products`,
    viewBrandRoute: "/brands/:id/:slug",
    viewCategory: (category: Category) =>
      `/categories/${category?.id}/${category?.slug}`,
    viewBrand: (brand: Brand) => `/brands/${brand?.id}/${brand?.slug}`,
  },
  contactUs: "/contact-us",
  pages: {
    aboutUs: "/about-us",
    termsConditions: "/terms-conditions",
    privacyPolicy: "/privacy-policy",
    exchangeAndReturnPolicy: "/exchange-and-return-policy",
    viewRoute: "/pages/:slug/:id",
    view: (page: any) => `/pages/${page.slug}/${page.id}`,
  },
  newsletters: "/newsletters",
  uploads: "/uploads",
  aboutUs: "/about-us",
  orderRequest: "/order-request",
  menu: "/menu",
};
